<!-- 区中心首页页面 -->
<script>
// 加载中
import InnerLoading from '@/components/spinner/spinner.vue';
// 动态表单模版
import {getLocalItem} from "@/untils/common";
import {ClientId} from "@/lib/cli";
import {consumablesWareHouseOrderInfo, consumablesWareHouseStatistics, warehouseInfoList} from "@/lib/request";
export default {
  name:'centerHome',
  data(){
    return{
      innerLoading:false,
      storefrontPhoto:'',
      objWareHouse:{},
      warehouseName:'',
      warehouseList:[
        // {id:1,name:'北郊大厅'},
        // {id:2,name:'区中心'},
        // {id:3,name:'那曲仓库'},
      ],
      showWarehousePicker:false,
      shopNumber:null,
      confirmFlag:false,
      confirmTitle:'1',//1:入库，2：调拨
      confirmAddFlag:false,
      confirmMoveFlag:false,
      //------
      fileVideoUrl:'/api/resource/oss/upload',//接口前缀加api
      headers:{
        'isEncrypt':true,
        'Authorization': 'Bearer ' + getLocalItem('access_token'),
        'clientid' : ClientId,
      },
      loading:false,
      imgFlag2: false,
      //是否显示进度条
      imgUploadPercent2: 0,
      //进度条的进度，
      isShowUploadImg2: false,
      //显示上传按钮
      imgForm2: {
        showVideoPath: "",  //回显的变量
      },
      objStatistics:{}
    }
  },
  components:{
    InnerLoading,
  },
  methods:{
    setAdmin(type){
      this.$router.push({path:type});
    },
    getInspection(type){
      if(type>2){
        console.log(type)
      }else{
        this.$router.push({path:'/channelConsume',query:{type:type}});
      }
    },
    getModel(type){
      this.innerLoading = true;
      if(type==='consume'){
        this.innerLoading = false;
        this.confirmAddFlag = true;
        // this.$toast('开发中，敬请期待！');
        // this.$router.push({path:'/consume'});
      }else if(type==='consumables'){
        this.innerLoading = false;
        this.confirmMoveFlag = true;
        // this.$toast('开发中，敬请期待！');
        // this.$router.push({path:'/consume'});
      }
    },
    // 上传照片 oss
    beforeUploadImg2(file) {
      if (
          ["image/png","image/jpg", "image/jpeg",].indexOf(file.type) === -1     //控制格式
      ) {
        this.$toast("请上传正确的图片格式");
        return false;
      }
      let fileSize = file.size / 1024 / 1024 < 500;   //控制大小  修改50的值即可
      if (!fileSize) {
        this.$toast("图片大小不能超过500MB");
        return false;
      }
      this.isShowUploadImg2 = false;
      this.imgForm2.showVideoPath = URL.createObjectURL(file);
    },
    //进度条
    uploadImgProcess2(event, file, fileList) {    //注意在data中添加对应的变量名
      this.imgFlag2 = true;
      this.imgUploadPercent2 = file.percentage.toFixed(0) * 1;
    },
    //上传成功回调
    handleImgSuccess2(res, file) {
      this.loading = true;
      this.isShowUploadImg2 = true;
      this.imgFlag2 = false;
      this.imgUploadPercent2 = 0;
      //后台上传数据
      if (res.code === 200) {
        if(res.data){
          this.loading = false;
          this.storefrontPhoto = res.data.url;
        }
      } else {
        this.$toast(res.msg);
        return false;
      }
    },
    beforeDelete() {
      this.imgForm2 = {};
      this.imgForm2.showVideoPath = '';
      this.storefrontPhoto = '';
    },
    onWarehouseConfirm(values){
      this.warehouseName = values.warehouseName;
      this.objWareHouse = values;
      this.showWarehousePicker = false;
    },
    // 入库提交
    getSubmitAdd(){
      if(parseInt(this.shopNumber)>0){
        // if(parseInt(this.shopNumber)>parseInt(this.objStatistics.centralStockNumber)){
        //   this.$toast('不能超过总库存数量，请检查您填写的数量！');
        // }else{
        this.confirmFlag = true;
        this.confirmTitle = '1';
        // }
      }else{
        this.$toast('请填写入库数量');
      }
    },
    cancelAdd(){
      this.shopNumber = null;
      this.confirmFlag = false;
      this.confirmAddFlag = false;
    },
    // 调拨提交
    getSubmitMove(){
      if(parseInt(this.shopNumber)>0){
        if(parseInt(this.shopNumber)>parseInt(this.objStatistics.centralStockNumber)){
          this.$toast('不能超过总库存数量，请检查您填写的数量！');
        }else {
          if(this.warehouseName===''){
            this.$toast('请选择调拨仓库！');
            return false;
          }else if(this.storefrontPhoto===''){
            this.$toast('请检查订单图片是否上传成功！');
            return false;
          }else{
            this.confirmFlag = true;
            this.confirmTitle = '2';
          }
        }
      }else{
        this.$toast('请填写入库数量');
      }
    },
    cancelMove(){
      this.shopNumber = null;
      this.storefrontPhoto = '';
      this.objWareHouse = {};
      this.warehouseName = '';
      this.imgForm2.showVideoPath="";
      this.confirmFlag = false;
      this.confirmAddFlag = false;
    },
    // 输入申请数量
    getOnInput(){
      // 库存小于等于限制数量时
      if(parseInt(this.shopNumber)>parseInt(this.objStatistics.centralStockNumber)){
        this.shopNumber = parseInt(this.objStatistics.centralStockNumber);
      }
    },
    getSubmitForm(){
      let params = {};
      params.boxNumber = parseInt(this.shopNumber);
      if(this.confirmTitle==='1'){
        params.targetWhId = "ck-000";//固定值'ck-000'
        params.whId = "";// 空值，不用填写
      }else{
        params.applicationFormUrl = this.storefrontPhoto;
        params.whId =  "ck-000";  //固定值'ck-000'
        params.targetWhId = this.objWareHouse.whId;
      }
      this.innerLoading = true;
      console.log(params)
      consumablesWareHouseOrderInfo(params).then((res)=>{
        if(res){
          if(!res.data){
            return false;
          }
          if(res.data.code===200){
            console.log(res.data)
            this.shopNumber = null;
            this.storefrontPhoto = '';
            this.objWareHouse = {};
            this.warehouseName = '';
            this.imgForm2.showVideoPath="";
            this.confirmFlag = false;
            this.confirmAddFlag = false;
            this.confirmMoveFlag = false;
            this.getNumberState();
            this.$toast.success('订单提交成功！');
          }else{
            this.$toast.fail('订单提交失败！');
          }
          this.innerLoading = false;
        }
      })
    },
    getNumberState(){
      consumablesWareHouseStatistics({
        warehouseName:this.warehouseNameStr,
      }).then((res)=>{
        if(res){
          if(!res.data){
            return;
          }
          if(!res.data.data){
            return;
          }
          console.log(res.data)
          this.objStatistics = res.data.data;
        }
      });
    },

    getWareHouseList(){
      warehouseInfoList({
        type:1,
        pageSize:20,
        pageNum:1,
      }).then((res)=>{
        if(res){
          console.log(res)

          if(!res.data){
            return false;
          }
          if(!res.data.rows){
            return false;
          }
          this.warehouseList = res.data.rows;
        }
      })
    }
  },
  created(){
  }
}
</script>
<template>
  <div class="tech-content">
    <div class="card">
      <div class="card-title">
        <span>📋 绩效管理</span>
      </div>
      <div class="function-grid">
        <div class="function-card" @click="setAdmin('/centerSet')">
          <div class="function-icon">🗒</div>
          <div class="function-name">设置绩效考核</div>
        </div>
      </div>
<!--      <div class="function-grid" style="grid-template-columns: repeat(3, 1fr); gap: 10px; margin-bottom: 0!important;">-->
<!--        <div class="function-card inspection-items" @click="setAdmin('/centerSet')">-->
<!--          <div class="function-name">绩效考核</div>-->
<!--        </div>-->
<!--        <div class="function-card inspection-items" @click="setAdmin('/centerReward')">-->
<!--          <div class="function-name">奖励记录</div>-->
<!--          <div class="tack-green">0</div>-->
<!--        </div>-->
<!--        <div class="function-card inspection-items" @click="setAdmin('/centerPenalty')">-->
<!--          <div class="function-name">惩戒记录</div>-->
<!--          <div class="task-count">11</div>-->
<!--        </div>-->
<!--      </div>-->
    </div>
<!--    <div class="prediction-notice">-->
<!--      当前库存： <span class="remainingRolls">{{ objStatistics.centralStockNumber }}</span>箱-->
<!--    </div>-->
<!--    <div class="card">-->
<!--      <div class="card-title">-->
<!--        <span>热敏纸记录</span>-->
<!--      </div>-->
<!--      <div class="function-grid" style="grid-template-columns: repeat(2, 1fr); gap: 10px; margin-bottom: 0;">-->
<!--        <div class="function-card inspection-item" @click="getInspection(1)">-->
<!--          <div class="function-name">入库记录</div>-->
<!--          <div class="task-count"><span>本月入库：</span>{{ objStatistics.currentMonthStoreNumber }}箱</div>-->
<!--        </div>-->
<!--        <div class="function-card inspection-item" @click="getInspection(2)">-->
<!--          <div class="function-name">调拨记录</div>-->
<!--          <div class="task-count"><span>本月调拨：</span>{{ objStatistics.currentMonthAllocationNumber }}箱</div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="function-grid" style="grid-template-columns: repeat(2, 1fr); gap: 10px; margin-bottom: 0;">-->
<!--        <div class="function-card inspection-item" @click="getInspection(3)">-->
<!--          <div class="function-name">奖励记录</div>-->
<!--          <div class="task-count">{{ objStatistics.currentMonthStoreNumber }}条</div>-->
<!--        </div>-->
<!--        <div class="function-card inspection-item" @click="getInspection(4)">-->
<!--          <div class="function-name">惩戒记录</div>-->
<!--          <div class="task-count">{{ objStatistics.currentMonthAllocationNumber }}条</div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <!-- 功能区 -->
<!--    <div class="card">-->
<!--      <div class="card-title">-->
<!--        <span>热敏纸管理</span>-->
<!--      </div>-->
<!--      <div class="function-grid">-->
<!--        <div class="function-card" @click="getModel('consume')">-->
<!--          <div class="function-icon">📦</div>-->
<!--          <div class="function-name">区中心入库</div>-->
<!--        </div>-->
<!--        <div class="function-card" @click="getModel('consumables')">-->
<!--          <div class="function-icon">🚚</div>-->
<!--          <div class="function-name">热敏纸调拨</div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <!--    销量-->
<!--    <div class="card">-->
<!--      <div class="region-grid" id="allRegionSalesGrid">-->
<!--        <div class="region-card">-->
<!--          <div class="region-name" style="color: var(&#45;&#45;primary-color); font-weight: 700;">全区总销量</div>-->
<!--          <div class="region-amount" data-month="¥45,680,000" data-year="¥512,340,000">¥45,680,000</div>-->
<!--          <div class="region-growth">-->
<!--            <i class="fas fa-arrow-up"></i> 同比 +8.5%-->
<!--          </div>-->
<!--        </div>-->

<!--        <div class="region-card">-->
<!--          <div class="region-name">拉萨市</div>-->
<!--          <div class="region-amount" data-month="¥15,240,000" data-year="¥178,560,000">¥15,240,000</div>-->
<!--          <div class="region-growth">-->
<!--            <i class="fas fa-arrow-up"></i> +12.3%-->
<!--          </div>-->
<!--        </div>-->

<!--        <div class="region-card">-->
<!--          <div class="region-name">日喀则市</div>-->
<!--          <div class="region-amount" data-month="¥8,950,000" data-year="¥102,340,000">¥8,950,000</div>-->
<!--          <div class="region-growth">-->
<!--            <i class="fas fa-arrow-up"></i> +6.8%-->
<!--          </div>-->
<!--        </div>-->

<!--        <div class="region-card">-->
<!--          <div class="region-name">山南市</div>-->
<!--          <div class="region-amount" data-month="¥6,780,000" data-year="¥78,920,000">¥6,780,000</div>-->
<!--          <div class="region-growth">-->
<!--            <i class="fas fa-arrow-up"></i> +9.2%-->
<!--          </div>-->
<!--        </div>-->

<!--        <div class="region-card">-->
<!--          <div class="region-name">林芝市</div>-->
<!--          <div class="region-amount" data-month="¥5,340,000" data-year="¥61,850,000">¥5,340,000</div>-->
<!--          <div class="region-growth">-->
<!--            <i class="fas fa-arrow-up"></i> +7.5%-->
<!--          </div>-->
<!--        </div>-->

<!--        <div class="region-card">-->
<!--          <div class="region-name">昌都市</div>-->
<!--          <div class="region-amount" data-month="¥4,680,000" data-year="¥54,210,000">¥4,680,000</div>-->
<!--          <div class="region-growth">-->
<!--            <i class="fas fa-arrow-up"></i> +5.3%-->
<!--          </div>-->
<!--        </div>-->

<!--        <div class="region-card">-->
<!--          <div class="region-name">那曲市</div>-->
<!--          <div class="region-amount" data-month="¥2,890,000" data-year="¥33,460,000">¥2,890,000</div>-->
<!--          <div class="region-growth negative">-->
<!--            <i class="fas fa-arrow-down"></i> -2.1%-->
<!--          </div>-->
<!--        </div>-->

<!--        <div class="region-card">-->
<!--          <div class="region-name">阿里地区</div>-->
<!--          <div class="region-amount" data-month="¥1,800,000" data-year="¥21,000,000">¥1,800,000</div>-->
<!--          <div class="region-growth">-->
<!--            <i class="fas fa-arrow-up"></i> +3.8%-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <!-- 分游戏销量统计 -->
<!--    <div class="card">-->
<!--      <h3 >-->
<!--        <i class="fas fa-gamepad"></i> 分游戏销量统计-->
<!--      </h3>-->
<!--      <div class="game-types-container">-->
<!--      <div class="game-sales-module computer-block">-->
<!--        <div class="game-type-header">-->
<!--          <div class="game-type-info">-->
<!--            <div class="game-type-name">电脑票销量</div>-->
<!--            <div class="game-type-total" id="computerTotal" data-month="¥25,150,000" data-year="¥294,540,000">¥25,150,000</div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="game-sales-module scratch-block">-->
<!--        <div class="game-type-header">-->
<!--          <div class="game-type-info">-->
<!--            <div class="game-type-name">即开票销量</div>-->
<!--            <div class="game-type-total" id="scratchTotal" data-month="¥20,530,000" data-year="¥238,480,000">¥20,530,000</div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    </div>-->
      <!--    区中心仓库入库-->
<!--    <van-popup-->
<!--        v-model="confirmAddFlag"-->
<!--        round-->
<!--        position="center"-->
<!--        closeable-->
<!--        close-icon-position="top-right"-->
<!--        :close-on-click-overlay="false"-->
<!--        @close="cancelAdd"-->
<!--        :style="{width:'90%',height:'auto'}"-->
<!--    >-->
<!--      <div class="">-->
<!--        <div class="form-section">-->
<!--          <div class="supply-item">-->
<!--            <div class="supply-header">-->
<!--              <div class="supply-name">📦 区中心入库</div>-->
<!--            </div>-->
<!--            <div class="quantity-section">-->
<!--              <div class="quantity-input">-->
<!--                <span class="quantity-label">入库数量（箱）</span>-->
<!--                <div class="quantity-controls">-->
<!--                  <van-field-->
<!--                      v-model="shopNumber"-->
<!--                      name="shopNumber"-->
<!--                      label=""-->
<!--                      type="number"-->
<!--                      placeholder="请填写入库数量（箱）"-->
<!--                      :rules="[{ required: true, message: '请填写入库数量（箱）' }]"-->
<!--                  />-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="quantity-btn" @click="getSubmitAdd()">确认入库</div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </van-popup>-->
    <!--    仓库列表弹窗-->
<!--    <van-popup-->
<!--        v-model="showWarehousePicker"-->
<!--        round-->
<!--        position="bottom"-->
<!--    >-->
<!--      <van-picker-->
<!--          show-toolbar-->
<!--          title="仓库"-->
<!--          :columns="warehouseList"-->
<!--          value-key="warehouseName"-->
<!--          @confirm="onWarehouseConfirm"-->
<!--          @cancel="showWarehousePicker = false"-->
<!--      />-->
<!--    </van-popup>-->
    <!--    热敏纸调拨申请-->
<!--    <van-popup-->
<!--        v-model="confirmMoveFlag"-->
<!--        round-->
<!--        position="center"-->
<!--        closeable-->
<!--        close-icon-position="top-right"-->
<!--        :close-on-click-overlay="false"-->
<!--        @close="cancelMove"-->
<!--        :style="{width:'90%',height:'auto'}"-->
<!--    >-->
<!--      <div class="" >-->
<!--        <div class="form-section">-->
<!--          <div class="supply-item">-->
<!--            <div class="supply-header">-->
<!--              <div class="supply-name">🚚 热敏纸调拨</div>-->
<!--            </div>-->
<!--            <div class="quantity-section">-->
<!--              <div class="warehouse-section">-->
<!--                <div class="warehouse-label">选择仓库</div>-->
<!--                <div class="form-item">-->
<!--                  <van-field-->
<!--                      v-model="warehouseName"-->
<!--                      name="warehouseName"-->
<!--                      label=""-->
<!--                      placeholder="请选择仓库"-->
<!--                      :rules="[{ required: true, message: '请选择仓库' }]"-->
<!--                      readonly-->
<!--                      @click="showWarehousePicker = true"-->
<!--                  >-->
<!--                    <template #right-icon>-->
<!--                      <van-icon name="arrow-down" />-->
<!--                    </template>-->
<!--                  </van-field>-->

<!--                </div>-->
<!--              </div>-->
<!--              <div class="quantity-input">-->
<!--                <span class="quantity-label">调拨数量（箱）</span>-->
<!--                <div class="quantity-controls">-->
<!--                  <van-field-->
<!--                      v-model="shopNumber"-->
<!--                      name="shopNumber"-->
<!--                      label=""-->
<!--                      type="number"-->
<!--                      @keyup="getOnInput()"-->
<!--                      placeholder="请填写调拨数量（箱）"-->
<!--                      :rules="[{ required: true, message: '请填写入库数量（箱）' }]"-->
<!--                  />-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="warehouse-section">-->
<!--                <div class="warehouse-label">订单图片</div>-->
<!--                <div class="group-video">-->
<!--                  <div class="group-video-load" >-->
<!--                    <el-upload-->
<!--                        id="upload_Id2"-->
<!--                        class="avatar-uploader"-->
<!--                        :action="fileVideoUrl"-->
<!--                        :headers="headers"-->
<!--                        v-model="imgForm2.showVideoPath"-->
<!--                        accept="image/jpeg, image/jpg, image/png"-->
<!--                        v-bind:on-progress="uploadImgProcess2"-->
<!--                        v-bind:on-success="handleImgSuccess2"-->
<!--                        v-bind:before-upload="beforeUploadImg2"-->
<!--                        v-bind:show-file-list="false"-->
<!--                        capture="camera"-->
<!--                    >-->
<!--                      <div v-if="(imgForm2.showVideoPath !== '') && !imgFlag2" v-bind:src="imgForm2.showVideoPath" class="avatar video-avatar" controls="controls">-->
<!--                        <img :src="imgForm2.showVideoPath" alt="" />-->
<!--                      </div>-->
<!--                      <div class="group-load-item" v-else-if="(imgForm2.showVideoPath==='') && !imgFlag2" >-->
<!--                        <div class="video-icon-img"><i class="el-icon-camera"></i></div>-->
<!--                        <div class="video-icon-txt">上传</div>-->
<!--                      </div>-->
<!--                      <el-progress v-if="imgFlag2 === true" type="circle" v-bind:percentage="imgUploadPercent2" style="text-align: center;"></el-progress>-->
<!--                    </el-upload>-->
<!--                    <div v-if="(imgForm2.showVideoPath !== '') && !imgFlag2" class="aod" @click="beforeDelete()">&times;</div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="quantity-btn" @click="getSubmitMove">执行调拨</div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </van-popup>-->

    <!--    确认入库数量并提交-->
<!--    <van-popup-->
<!--        v-model="confirmFlag"-->
<!--        round-->
<!--        position="center"-->
<!--        closeable-->
<!--        close-icon-position="top-right"-->
<!--        :close-on-click-overlay="false"-->
<!--        :style="{width:'90%',height:'auto'}"-->
<!--    >-->
<!--      <inner-loading v-model="innerLoading"></inner-loading>-->
<!--      <div class="inner-firm">-->
<!--        <div class="modal-title-info">-->
<!--          {{confirmTitle==='1'?'📦 确认入库':'🚚 确认调拨'}}-->
<!--        </div>-->
<!--        <div class="modal-content-info">-->
<!--          <div class="modal-detail-info" v-show="confirmTitle==='1'">-->
<!--            <span class="modal-detail-label">入库数量：</span>-->
<!--            <span class="modal-detail-value">{{shopNumber}}箱</span>-->
<!--          </div>-->
<!--          <div class="modal-detail-info" v-show="confirmTitle==='1'">-->
<!--            <span class="modal-detail-label">入库后库存：</span>-->
<!--            <span class="modal-detail-value">{{parseInt(objStatistics.centralStockNumber)+parseInt(shopNumber)}}箱</span>-->
<!--          </div>-->
<!--          <div class="modal-detail-info" v-show="confirmTitle==='2'">-->
<!--            <span class="modal-detail-label">目标仓库：</span>-->
<!--            <span class="modal-detail-value">{{objWareHouse.warehouseName}}</span>-->
<!--          </div>-->
<!--          <div class="modal-detail-info" v-show="confirmTitle==='2'">-->
<!--            <span class="modal-detail-label">数量：</span>-->
<!--            <span class="modal-detail-value">{{shopNumber}}箱</span>-->
<!--          </div>-->
<!--          <div class="modal-detail-info" v-show="confirmTitle==='2'">-->
<!--            <span class="modal-detail-label">调拨后库存：</span>-->
<!--            <span class="modal-detail-value">{{parseInt(objStatistics.centralStockNumber)-parseInt(shopNumber)}}箱</span>-->
<!--          </div>-->
<!--          <div class="modal-detail-info" v-show="confirmTitle==='2'">-->
<!--            <span class="modal-detail-label">订单图片：</span>-->
<!--            <span class="modal-detail-value"><img :src="imgForm2.showVideoPath" alt=""></span>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="form-buttons">-->
<!--          <van-button round block plain type="default" @click="confirmFlag=!confirmFlag" style="background: #f5f5f5;border:none;"-->
<!--                      native-type="button">取消-->
<!--          </van-button>-->
<!--          <van-button round block type="primary" color="#e62d2d" @click="getSubmitForm">{{confirmTitle==='1'?'确认入库':'确认调拨'}}-->
<!--          </van-button>-->
<!--        </div>-->
<!--      </div>-->
<!--    </van-popup>-->
  </div>
</template>
<style scoped lang="scss">
.tech-content{
  font-size: 28px;
  padding-top: 120px;
  box-sizing: border-box;
}

.inner-firm{
  display: flex;
  width: 100%;
  height: auto;
  padding: 20px;
  flex-direction: column;
  .modal-title-info{
    text-align: center;
    font-size: 36px;
    padding: 20px;
    font-weight: 600;
    color: #2d3436;
    margin-bottom: 20px;
    display: flex
  ;
    align-items: center;
    justify-content: center;
  }
  .modal-content-info{
    display: flex;
    flex-direction: column;
    .modal-detail-info{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding: 10px 20px;
      .modal-detail-label{
        color:#6c757d
      }
      .modal-detail-value {
        color: #2d3436;
        font-weight: 600;
        img{
          width: 230px;
        }
      }
    }
  }
}
/* 销售数据卡片样式 */
.sales-area {
  background: white;
  border-radius: 10px;
  padding: 25px 0;
  margin-bottom: 25px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.05);
  border: 1px solid rgba(0,0,0,0.04);
  display: flex;
  flex-direction: column;
}
.sales-area-all{
  display: flex;
  flex-direction: row;
}
.sales-area-num{
  display: flex;
  flex-direction: row;
}
.sales-area-title {
  width: 100%;
  font-weight: bold;
  color: #333;
  font-size: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 15px;
}


.sales-data {
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-between;
}

.sales-data-item {
  flex: 1;
  text-align: center;
  padding: 0 5px;
}

//.sales-data-item:last-child {
//  border-right: none;
//}

.sales-label {
  color:#666;
  margin-bottom: 15px;
}

.sales-value {
  font-weight: bold;
  color:#e62d2d;
  margin: 5px 0;
  display: flex;
  align-items: baseline;
  justify-content: center;
}

.sales-value span {
  font-weight: bold;
  color:#e62d2d;
}
.total-sales-value {
  font-size: 36px;
  font-weight: bold;
  color: #e62d2d;
  display: flex;
  align-items: baseline;
  justify-content: center;
}

.total-sales-value span {
  font-size: 26px;
  font-weight: bold;
  margin-left: 2px;
}
.total-sales {
  display: flex;
  width: 100%;
  text-align: center;
  justify-content: center;
  padding-bottom: 15px;
}
.card-title {
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #333;
}
/* 工作任务卡片 */
.function-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
  margin-bottom: 15px;
}

.function-card {
  background: white;
  border-radius: 6px;
  padding: 25px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 5px rgba(0,0,0,0.05);
  border: 1px solid rgba(0,0,0,0.04);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  position: relative;
  //min-height: 100px;
}

.function-card:active {
  transform: translateY(1px);
  box-shadow: 0 1px 2px rgba(0,0,0,0.05);
}

.inspection-item {
  background: linear-gradient(135deg, #fff, #f9f9f9);
}

.function-icon {
  font-size: 44px;
  margin-bottom: 5px;
  color: #e62d2d;
  i{
    font-size: 44px;
  }
}

.function-name {
  color: #333;
  font-weight: 500;
}
.task-count {
  font-size: 26px;
  font-weight: bold;
  color: #e62d2d;
  margin-top: 15px;
  position: relative;
  span{
    color: #222;
  }
}

.task-count::before {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  height: 4px;
  background-color: rgba(230, 45, 45, 0.1);
  border-radius: 2px;
  z-index: -1;
}

.form-section {
  padding: 0;
}

.warehouse-label {
  font-size: 28px;
  color: #495057;
  margin-bottom: 8px;
  font-weight: 500;
}
.form-item .van-cell{
  border: 2px solid #e9e9e9;
}
.modal-options{
  padding: 0 30px;
  display: flex;
  flex-wrap: wrap;
}
.modal-option{
  background-color: #f5f5f5;
  border-radius: 35px;
  padding: 5px 35px;
  margin-right: 25px;
  margin-bottom: 20px;
  color: #666;
  border: 2px solid #8f8f8f;
}
.active{
  background-color: #e62d2d;
  border: 2px solid #e62d2d;
  color: white;
}


.supply-item {
  background: white;
  //border: 2px solid #e17055;
  border-radius: 12px;
  margin-bottom: 15px;
  overflow: hidden;
  transition: all 0.3s ease;
  padding: 20px;
  //box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.supply-item:hover {
  border-color: #e17055;
  box-shadow: 0 4px 12px rgba(225, 112, 85, 0.1);
}

.supply-header {
  padding:30px 20px;
  //background: linear-gradient(135deg, #fff5f3 0%, #fef5f3 100%);
}

.supply-name {
  font-size: 38px;
  font-weight: 600;
  color: #2d3436;
  margin-bottom: 10px;
}

.supply-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;

}

.quantity-section {
  background: white;
  padding:0 20px;
  //border-top: 1px solid #f1f3f4;
}

.quantity-input {
  display: flex;
  flex-direction: column;
  //align-items: center;
  margin-bottom: 25px;
}

.quantity-label {
  font-size: 28px;
  color: #495057;
  margin-right: 15px;
  margin-bottom: 25px;
  min-width: 80px;
  font-weight: 500;
}

.quantity-controls {
  display: flex;
  width: 100%;
  //box-shadow: 0 2px 8px rgba(10,10,10,0.3);
  border: 2px solid #e9ecef;
  border-radius: 10px;
  //overflow: hidden;
  //opacity: 0.5;
}

.quantity-btn {
  background: #e62d2d;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: not-allowed;
  padding: 20px 40px;
  margin: 10px 20px;
  color: #fff;
  font-weight: 600;
  border-radius: 10px;
}

.quantity-input input {
  border: none;
  width: 170px;
  height: 45px;
  text-align: center;
  background: #f8f9fa;
  font-weight: 600;
  color: #6c757d;
  cursor: not-allowed;
}
.application-content {
  padding: 20px;
}

.application-item {
  background: white;
  border-radius: 12px;
  padding: 28px;
  margin-bottom: 15px;
  //border-left: 4px solid #00b894;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  transition: all 0.3s ease;
  display: flex;
  justify-content: space-between;
  //align-items: center;
}

.application-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
}

/* --- ADDED --- */
.application-info-wrapper {
  margin-right: 15px;
}

.application-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px; /* MODIFIED */
}

.application-id {
  font-size: 28px;
  color: #495057;
  font-weight: 600;
}

.application-details {
  /* --- MODIFICATION START --- */
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 8px 20px; /* row-gap column-gap */
  /* --- MODIFICATION END --- */
  color: #6c757d;
  line-height: 1.6;
  margin-bottom: 0; /* MODIFIED */
}

.detail-item {
  display: flex;
  /* --- REMOVED justify-content: space-between; --- */
  gap: 5px; /* ADDED */
}

.box-detail-label {
  color: #6c757d;
}

.detail-value {
  color: #2d3436;
  font-weight: 600;
}

.quantity-highlight {
  color: #e17055;
  font-weight: 700;
  font-size: 28px;
}

.network-code {
  color: #0984e3;
  font-family: 'Monaco', 'Consolas', monospace;
}

.action-buttons {
  text-align: right;
  flex-shrink: 0;
}
.record-time{
  color: #6c757d;
  background: #f8f9fa;
  padding: 8px 20px;
  border-radius: 22px;
}
.action-btn {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.outbound-btn {
  background: linear-gradient(135deg, #e17055 0%, #d63031 100%);
  color: white;
}

.outbound-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(225, 112, 85, 0.3);
}

.outbound-btn:disabled {
  background: #bbb;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.group-video{
  border: 1px dashed #afafaf;
  border-radius: 10px;
  height: 37vw;
  width: 37vw;
  margin-top: 20px;
  margin-bottom: 20px;
  position: relative;
  .group-video-load{
    position: relative;
    border-radius: 10px;
    height:100%;
    width:100%;
    border:1px dashed #e9e9e9;
    overflow: hidden;
    .avatar-uploader{
      display: flex;
      width:100%;
      height:100%;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      .el-upload{
        width:100%;
        height:100%;
        .avatar{
          width:100%;
          height:100%;
          img{
            width:100%;
            height:100%;
          }
        }
      }
    }
    .group-load-item{
      position: absolute;
      top:50%;
      left:50%;
      z-index:1;
      transform:translate(-50%,-50%);
      border-radius:10px;
      padding:70px 0;
      text-align: center;
      width:100%;
      height:100%;
      font-size: 28px;
      .video-icon-img{
        width: 80px;
        height: 50px;
        margin: 0 auto;
        font-size: 60px;
        color: #ababab;
        img{
          width: 80px;
          height: 50px;
        }
      }
      .video-icon-txt{
        color: #ababab;
        padding-top: 20px;
      }
    }
    .aod{
      position: absolute;
      right: 0;
      top:0;
      z-index: 10000;
      color: #fff;
      font-size: 30px;
      height: 44px;
      line-height: 44px;
      width: 44px;
      text-align: center;
      background: #222;
      border-radius: 0 12px 0 0.32rem;
    }
  }
}
/* 地区销量卡片 */
.region-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 15px;
  margin-bottom: 25px;
}

.region-card {
  background: linear-gradient(135deg, #fff 0%, #f9f9f9 100%);
  border: 2px solid var(--border-color);
  border-radius: var(--radius-md);
  padding: 15px;
  text-align: center;
  transition: all 0.3s ease;
}

.region-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  border-color: var(--primary-color);
}

.region-name {
  font-size: 24px;
  font-weight: 600;
  color: var(--text-color);
  margin-bottom: 10px;
}

.region-amount {
  font-size: 30px;
  font-weight: 700;
  color: var(--primary-color);
  margin-bottom: 5px;
}

.region-growth {
  font-size: 22px;
  color: var(--success-color);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.region-growth.negative {
  color: var(--warning-color);
}
/* 游戏销量模块 */
.game-sales-module {
  background: transparent;
  border: none;
  border-radius: 0;
  padding: 0;
  margin-bottom: 20px;
  transition: all 0.3s ease;
}

.game-sales-module:hover {
  box-shadow: none;
  border-color: transparent;
}

/* 游戏类型容器 - 并排布局 */
.game-types-container {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.game-types-container .game-sales-module {
  flex: 1;
  border-radius: var(--radius-md);
  padding: 30px 25px;
  margin-bottom: 0;
  border: none;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.game-types-container .game-sales-module:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

/* 电脑票彩色背景 */
.game-types-container .computer-block {
  background: linear-gradient(135deg, #2196F3 0%, #1976D2 100%);
}

/* 即开票彩色背景 */
.game-types-container .scratch-block {
  background: linear-gradient(135deg, #FF9800 0%, #F57C00 100%);
}
</style>